function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.32813 0.242187L0.593751 2.94922C0.539063 3.02213 0.51172 3.09505 0.51172 3.16797C0.51172 3.25911 0.539063 3.34114 0.593751 3.41406L3.32813 6.12109C3.41927 6.23047 3.53776 6.25781 3.68359 6.20312C3.8112 6.14844 3.875 6.04818 3.875 5.90234L3.875 3.96094L12.2969 3.96094C12.388 3.96094 12.4701 3.92448 12.543 3.85156C12.5977 3.77865 12.625 3.70573 12.625 3.63281L12.625 2.75781C12.625 2.66667 12.5977 2.58464 12.543 2.51172C12.4701 2.45703 12.388 2.42969 12.2969 2.42969L3.875 2.42969L3.875 0.460937C3.875 0.315103 3.8112 0.214843 3.68359 0.160155C3.53776 0.105468 3.41927 0.132812 3.32813 0.242187Z",
  fill: "currentColor"
});

var SvgLongArrowBack = function SvgLongArrowBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLongArrowBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/long-arrow-back.18ce0b8a.svg";
export { ForwardRef as ReactComponent };